import { styleConstants } from '@paywithextend/components'
import AiStarsIconV2 from 'ext-ui/svg/icon/AiStarsIconV2'
import React from 'react'
import SvgAlertCircledFilled from 'src/components/Svgs/SvgAlertCircledFilled'
import { TagIconWithTooltip } from 'src/components/TagIconWithTooltip/TagIconWithTooltip'
import Trns from 'src/localization/Trns'
import { useQueryCanUseAIExpenseCategories } from 'src/queries/organizations/automationSettings/automationSettings.queries'
import { css, CSSProp } from 'styled-components'

export const ExpenseDetailsSourceIcon: React.FC<{
  errorMessage?: string
  cssProps?: CSSProp
  generatedByPrediction: boolean
}> = (props): React.ReactElement => {
  const { data: canUseAI, isLoading: isCanUseAILoading } =
    useQueryCanUseAIExpenseCategories()
  const enableSuggestions = canUseAI || isCanUseAILoading

  if (props.errorMessage) {
    return (
      <TagIconWithTooltip
        cssProps={props.cssProps}
        testId={'automationRuleConflictTag'}
        iconBackgroundColor={styleConstants.colors.yellow_background_light}
        icon={
          <SvgAlertCircledFilled
            css={css`
              width: 16px;
              height: 16px;
              transform: scale(0.68);
              transform-origin: top left;
              overflow: visible;
            `}
            fill={styleConstants.colors.yellow_darkest}
          />
        }
        tooltipText={
          <Trns
            source={
              'There was a conflict applying rules to this transaction. Double-check the expense categories applied.'
            }
          />
        }
      />
    )
  } else if (props.generatedByPrediction && enableSuggestions) {
    return (
      <TagIconWithTooltip
        cssProps={props.cssProps}
        testId={'automationRulePredictionTag'}
        iconBackgroundColor={styleConstants.colors.purple_light}
        icon={
          <AiStarsIconV2
            fill={styleConstants.colors.purple_dark}
            width={16}
            height={16}
          />
        }
        tooltipText={
          <Trns
            source={'This category was predicted based on past transactions'}
          />
        }
      />
    )
  } else {
    return (
      <TagIconWithTooltip
        cssProps={props.cssProps}
        testId={'automationRuleAppliedTag'}
        iconBackgroundColor={styleConstants.colors.purple_light}
        icon={
          <AiStarsIconV2
            fill={styleConstants.colors.purple_dark}
            width={16}
            height={16}
          />
        }
        tooltipText={
          <Trns
            source={'This category has been automatically tagged for you'}
          />
        }
      />
    )
  }
}
